import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { localeEn as enLang } from './modules/i18n/vocabs/en';
import { localeId as idLang } from './modules/i18n/vocabs/id';

import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { Subject, filter, takeUntil } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';
import { TableStateService } from './services/table-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private broadcastService: MsalBroadcastService,
    private tableStateService: TableStateService,
  ) {
    // register translations
    this.translationService.loadTranslations(enLang, idLang);
  }

  ngOnInit() {
    this.modeService.init();
    this.broadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
      takeUntil(this._destroying$)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
